export default __webpack_public_path__ + "static/media/25.fd71f572.png";